module.exports = __webpack_public_path__ + "ee6ac766/img/upload-icon.9179ae4e.svg";